import React from 'react';
import { motion } from 'framer-motion';
import Section from './Section';
import { colors } from '../colors';

const ScreenshotPage = ({ projects }) => (
  <Section delay={0.8}>
    <h2 className="text-3xl font-bold mb-4" style={{ color: colors.primary }}>Project Screenshots</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {projects.map((project, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="bg-gray-800 rounded-lg overflow-hidden"
        >
          <img src={project.screenshot} alt={project.title} className="w-full h-48 object-cover" />
          <div className="p-4">
            <h3 className="text-xl font-semibold mb-2" style={{ color: colors.secondary }}>{project.title}</h3>
            <p className="text-sm" style={{ color: colors.text }}>{project.description}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </Section>
);

export default ScreenshotPage;